import "./ArticlesCardStyles.css";

import React from 'react';

import { NavLink } from "react-router-dom";

const ArticlesCard = (props) => {
  return (
    <NavLink to={props.view}>
    <div className="article-card">
      <img src={props.imgsrc} alt="Preview del artículo"/>
      <h2 className="article-title">{props.title}</h2>
    </div>
    </NavLink>
  )
}

export default ArticlesCard